/**
 * Window events that surface web-layer app updates to the React tree.
 *
 * Dispatched from non-React modules (pwaClient, runtimeAssetRecovery) and
 * consumed by WebUpdateBanner — never import React here.
 */

/** The Service Worker detected a new deployment; user can apply it explicitly. */
export const APP_UPDATE_AVAILABLE_EVENT = "doitify:app-update-available";

/**
 * A missing-chunk recovery is about to reload: React shows a countdown notice
 * ("new version deployed, refreshing in Ns") and must claim the event with
 * `preventDefault()`; otherwise a direct reload fallback kicks in.
 */
export const APP_UPDATE_RELOADING_EVENT = "doitify:app-update-reloading";

/** Auto-recovery for missing chunks exhausted its attempts; user must refresh. */
export const APP_UPDATE_REQUIRED_EVENT = "doitify:app-update-required";
